import React, { useMemo } from "react";
import { PROGRAM_SPECIFIC_NAMES } from "../Helpers/constants";
import DxpPageShell from "./Common/StandaloneFormViews/DxpPageShell";
import { resolveTemplateExternalHref } from "./Common/StandaloneFormViews/resolveExternalHref";
import {
  DxpBodyText,
  DxpHeading,
  DxpMessageCard,
  DxpNarrowColumn,
  DxpPrimaryButton,
} from "./dxpStandaloneUi";
import DxpRegistrationTopHeader from "./DxpRegistrationTopHeader";

const PROGRAM = "DXP";

function DifferentDomainInactiveMessage({ appType }: { appType?: string }) {
  const pp = PROGRAM_SPECIFIC_NAMES.DXP.partnerProgram;

  const programHomeHref = useMemo(
    () =>
      resolveTemplateExternalHref({
        endpointPath: "environment.aemHomePageUrl",
        redirect: {
          type: "external",
          path: "/technologyprogram/experiencecloud/home.html",
        },
      }),
    [],
  );

  if (appType) {
    return (
      <DxpPageShell appType={appType} requireCommonHeaders>
        <div className="dxp-inactive-compact-outer">
          <div className="dxp-inactive-compact-inner">
            <div className="dxp-inactive-compact-lead">
              The Adobe Technology Partner Team is reviewing your submission.
            </div>
            <div className="dxp-inactive-compact-panel">
              <DxpBodyText className="dxp-body-text--bold">
                Once your Application has been reviewed, check your email.
              </DxpBodyText>
              <DxpBodyText html="<b>If approved,</b> then you will receive an email asking you to verify your email address. once verified, then you will be an approved partner in the Adobe Exchange Partner Program for the Experiance Cloud." />
              <DxpBodyText html="<b>if rejected,</b> then we will notify you via a email." />
              <div className="dxp-flex-end dxp-mt-24">
                <DxpPrimaryButton
                  label="Go to Program Home"
                  onPress={() => {
                    if (programHomeHref) {
                      window.open(programHomeHref, "_self");
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </DxpPageShell>
    );
  }

  return (
    <>
      <DxpRegistrationTopHeader program={PROGRAM} />

      <DxpPageShell requireCommonHeaders>
        <div className="dxp-static-message-outer">
          <DxpNarrowColumn>
            <DxpMessageCard className="dxp-message-card--min-h-350">
              <DxpHeading>
                The Adobe {pp.portalTeam} is reviewing your submission.
              </DxpHeading>
              <DxpBodyText className="dxp-body-text--bold">
                Once your Application has been reviewed, check your email.
              </DxpBodyText>
              <DxpBodyText html="<b>If approved,</b> then you will receive an email asking you to verify your email address. once verified, then you will be an approved partner in the Adobe Exchange Partner Program for the Experience Cloud." />
              <DxpBodyText html="<b>If rejected,</b> then we will notify you via email." />
              <div className="dxp-flex-end dxp-mt-24">
                <DxpPrimaryButton
                  label="Go to Program Home"
                  onPress={() => {
                    if (programHomeHref) {
                      window.open(programHomeHref, "_self");
                    }
                  }}
                  variant="accent"
                  className="dxp-wizard-cta-inverse"
                />
              </div>
            </DxpMessageCard>
          </DxpNarrowColumn>
        </div>
      </DxpPageShell>
    </>
  );
}

export default DifferentDomainInactiveMessage;
